import React, { lazy, Suspense } from 'react';
import PropTypes from 'prop-types';
import MaskLoader from './subcomponents/loader';
import DisplayMessage from './subcomponents/displayMessage';
//import Login from './login/loginPage';
import { isEscSatisfied } from '../actions/commonActions';
import * as CommonActions from '../actions/commonActions';

const ClientStyles = lazy(() => import('./subcomponents/clientStyles'));
const Title = lazy(() => import('./subcomponents/title'));
const ApplicationTimeout = lazy(() => import('./subcomponents/applicationTimeout'));
const SideBarPanel = lazy(() => import('./subcomponents/sideBarPanel'));
const Header = lazy(() => import('./subcomponents/header'));
const Footer = lazy(() => import('./subcomponents/footer'));
const SideNav = lazy(() => import('./subcomponents/sideNav'));

class Default extends React.Component {
  constructor(props) {
    super(props);

    this.escFunction = this.escFunction.bind(this);
    this.state = {
      pathName: ''
    };
  }

  escFunction(event) {
    if (isEscSatisfied(event.keyCode)) {
      const location = window.location.pathname;
      this.props.displayDialog(location);
    }
  }

  componentWillMount() {
    this.props.displayCommonHeaderSideMenu();
    this.props.getTranslations();
  }


  componentDidMount() {
    const value = CommonActions.getWindowTitle(window.location.pathname);
    this.setState({ pathName: value });
    document.addEventListener('keydown', this.escFunction, false);
  }
  
  componentWillUnmount() {
    document.removeEventListener('keydown', this.escFunction, false);
  }

  // handleNavClick(event){
  //   event.preventDefault();
  //   const title = event.target.text;
  //   const{
  //     handleNavSelect
  //   } = this.props;
  //   handleNavSelect(title);
  // }


  render() {
    const {
      children,
      displayLoader,
      infoMessage,
      closeDisplayMessage,
      displayMessage,
      sideNavContent,
      clientColors,
      catalogPoints,
      catalogSymbol,
      catalogLink,
      banks,
      awards,
      catalogs,
      cartLink,
      activityMenu,
      customerLogoUrl,
      getAlerts,
      getBankDetails,
      getLayouts,
      getTranslations,
      translations,
      displaySideMenu,
      // authToken,
      // getUserName,
      // getUserPassword,
      // submitLogin,
      greeting,
      logout,
      alertsCount,
      genericAlerts,
      receiveAlerts,
      customerId,
      getPersonalDetails,
      customerLogoHome,
      hasGivenWidgetEnabled,
      banksCatalog,
      footerLinks,
      customerDateFormat,
      activeLanguage,
      setActiveLanguage,
      getActiveLanguage,
      getCatalogPoints,
      displaySessionTimeOut,
      displaySession,
      locale,
      getBankFilter,
      isDisplaySideBarPanel,
      displaySideBarPanel,
      getAvatar,
      avatarLink,
      tasksCount,
      customerTitle,
      handleNavSelect,
      isDisplayCommonHeaderSideMenu,
      getRecieveAlert,
      initializeVictoriesHeader,
      refreshVictoriesHeader
    } = this.props;
    // if(authToken === ''){
    //   return (<Login getUserName={getUserName} getUserPassword={getUserPassword} submitLogin={submitLogin} displayLoader={displayLoader}/>);
    // }
    return (
      <div className={`${isDisplayCommonHeaderSideMenu ?'main-container layout-vbox': 'access-main-container'}`}>
        <Suspense fallback={MaskLoader}>
          <ClientStyles {...clientColors}/>
        </Suspense>
        <Suspense fallback={MaskLoader}>
          <Title translations={translations}
            pathName={this.state.pathName}
            customerTitle={customerTitle} />
        </Suspense>
        <Suspense fallback={MaskLoader}>
          {isDisplayCommonHeaderSideMenu && <Header 
            hasGivenWidgetEnabled={hasGivenWidgetEnabled}
            displaySideMenu={displaySideMenu}
            customerLogoUrl={customerLogoUrl}
            customerId={customerId}
            activityMenu={activityMenu}
            cartLink={cartLink}
            translations={translations}
            banks={banks}
            awards={awards}
            catalogs={catalogs}
            catalogPoints={catalogPoints}
            catalogSymbol={catalogSymbol}
            catalogLink={catalogLink}
            getLayouts={getLayouts}
            getTranslations={getTranslations}
            getAlerts={getAlerts}
            greeting={greeting}
            logout={logout}
            alertsCount={alertsCount}
            genericAlerts={genericAlerts}
            receiveAlerts={receiveAlerts}
            getPersonalDetails={getPersonalDetails}
            getBankDetails={getBankDetails}
            customerHome = {customerLogoHome}
            banksCatalog={banksCatalog}
            customerDateFormat={customerDateFormat}
            getCatalogPoints={getCatalogPoints}
            activeLanguage={activeLanguage}
            locale={locale}
            displaySideBarPanel={displaySideBarPanel}
            isDisplaySideBarPanel={isDisplaySideBarPanel}
            getAvatar={getAvatar}
            tasksCount={tasksCount}
            getRecieveAlert={getRecieveAlert}
            initializeVictoriesHeader={initializeVictoriesHeader}
          />}
        </Suspense>
        <Suspense fallback={MaskLoader}>
          {isDisplaySideBarPanel && 
          <SideBarPanel 
            greeting={greeting}
            logout={logout}
            avatarLink={avatarLink}
            catalogPoints={catalogPoints}
            catalogSymbol={catalogSymbol}
            catalogLink={catalogLink}
            banks={banksCatalog.length > 0 ? banksCatalog : banks}
            awards={awards}
            catalogs={catalogs}
            translations={translations}
            customerDateFormat={customerDateFormat}
            activityMenu={activityMenu}
            alertsCount={alertsCount}
            genericAlerts={genericAlerts}
            receiveAlerts={receiveAlerts}
            tasksCount={tasksCount}
            cartLink={cartLink}/>}
        </Suspense>
        <div className={`${isDisplayCommonHeaderSideMenu ? 'default-container' : 'access-container'}`}>
          <Suspense fallback={MaskLoader}>
            {isDisplayCommonHeaderSideMenu && <SideNav
              sideNavContent={sideNavContent}
              //handleNavClick={this.handleNavClick}
              handleNavSelect={handleNavSelect}/>}
          </Suspense>
          <div className="view-container">
            {displayLoader && <MaskLoader />}
            {displayMessage && isDisplayCommonHeaderSideMenu && 
             <DisplayMessage
               infoMessage={infoMessage}
               closeDisplayMessage={closeDisplayMessage}
               translations={translations}
             />
            }
            {children}
          </div>
        </div>
        <Suspense fallback={MaskLoader}>
          {isDisplayCommonHeaderSideMenu && <Footer
            footerLinks={footerLinks}
            activeLanguage={activeLanguage}
            setActiveLanguage={setActiveLanguage}
            persistActiveLanguage={getActiveLanguage}
            getTranslations={getTranslations}
            translations={translations}
            applyFilter={getBankFilter}
            refreshVictoriesHeader={refreshVictoriesHeader}
          />}
        </Suspense>
        <Suspense fallback={MaskLoader}>
          {displaySessionTimeOut && isDisplayCommonHeaderSideMenu &&
          <ApplicationTimeout 
            displaySession={displaySession}
            logout={logout}
            translations={translations}/>}
        </Suspense>
        {isDisplaySideBarPanel && <div 
          className="bgCover"
          onClick={displaySideBarPanel.bind(this, isDisplaySideBarPanel)}></div>}
      </div>
    );
  }
}

Default.propTypes = {
  children: PropTypes.object,
  displayLoader: PropTypes.bool,
  infoMessage: PropTypes.object,
  closeDisplayMessage: PropTypes.func,
  displayMessage: PropTypes.bool,
  sideNavContent: PropTypes.object,
  handleChildItems: PropTypes.func,
  expandSubscriptions: PropTypes.func,
  displayOverlayLayer: PropTypes.func,
  getLayouts: PropTypes.func,
  customerLogoUrl: PropTypes.string,
  activityMenu: PropTypes.array,
  getBankDetails: PropTypes.func,
  hasGivenWidgetEnabled: PropTypes.bool,
  customerDateFormat:PropTypes.string,
  footerLinks:PropTypes.array,
  cartLink: PropTypes.string,
  catalogSymbol: PropTypes.string,
  catalogLink: PropTypes.string,
  banks: PropTypes.array,
  banksCatalog: PropTypes.array,
  translations: PropTypes.objectOf(PropTypes.string).isRequired,
  clientColors: PropTypes.object,
  customerTitle: PropTypes.string,
  tasksCount: PropTypes.number,
  avatarLink: PropTypes.string,
  displaySessionTimeOut: PropTypes.bool,
  activeLanguage: PropTypes.string
};

export default Default;
